import { render, staticRenderFns } from "./TerminalGame.vue?vue&type=template&id=6c590375&scoped=true&"
import script from "./TerminalGame.vue?vue&type=script&lang=js&"
export * from "./TerminalGame.vue?vue&type=script&lang=js&"
import style0 from "./TerminalGame.vue?vue&type=style&index=0&id=6c590375&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c590375",
  null
  
)

export default component.exports